export default i => {
  if (!i)
    return '';
  if (/^\+\d+$/.test(i))
    return `${i.substring(0, i.length - 10)} (${i.substr(-10, 3)}) ${i.substr(-7, 3)}-${i.substr(-4, 4)}`;
  if (/^anon\+[0-9a-f-]+@ellacard\.com$/.test(i))
    return 'Anonymous';
  return i;
};
